import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import fa from "./locales/fa.json";

// بررسی localStorage برای زبان ذخیره‌شده
let savedLanguage = localStorage.getItem("i18nextLng");

// اگر هیچ زبان ذخیره نشده بود، پیش‌فرض رو روی فارسی بذار
if (!savedLanguage) {
  savedLanguage = "fa";
  localStorage.setItem("i18nextLng", "fa");
}

i18n.use(initReactI18next).init({
  resources: {
    fa: { translation: fa },
    en: { translation: en },
  },
  lng: savedLanguage, // ← زبان اولیه از localStorage
  fallbackLng: "fa", // ← fallback در صورت اشتباه بودن مقدار
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["localStorage"],
    caches: ["localStorage"],
  },
});

export default i18n;
